import styled from 'styled-components'

export const Html = styled.div`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.pureBlack};

  & p {
    ${({ theme }) => theme.textStyles.textLarge}
    color: ${({ theme }) => theme.colors.nightRider};
    &:not(:last-child) {
      padding-bottom: 3rem;
    }
  }

  & h1,
  h2 {
    ${({ theme }) => theme.textStyles.H5}
    font-weight: 600;
    color: ${({ theme }) => theme.colors.royalBlue};

    &::after {
      content: '';
      display: block;
      width: 5rem;
      height: 0.2rem;
      background-color: ${({ theme }) => theme.colors.royalBlue};
      margin-top: 0.8rem;
      margin-bottom: 3rem;
    }
  }

  & h3 {
    ${({ theme }) => theme.textStyles.textLargeStrong}
    color: ${({ theme }) => theme.colors.nightRider};
    margin-bottom: 1.6rem;
  }

  & a {
    color: inherit;
  }
`
